document.addEventListener('DOMContentLoaded', function(){
	setModal();
	setModalAct();
});

const setModal =()=>{
	const thmbs=document.querySelectorAll(".questThmbs li img");
	const modal=document.querySelector(".modals");
	const temp=modal.querySelector("template");
	
	thmbs.forEach((thm)=>{
		const imgPath=thm.getAttribute("src");
		const mPath=imgPath.replace("_thmb", "");
		const clone = temp.content.cloneNode(true);
		clone.querySelector("img").src=mPath;
		modal.appendChild(clone);
	});
	temp.remove();
}

let mod=false;
const setModalAct =()=>{
	const thmbs=Array.from(document.querySelectorAll(".questThmbs li a"));
	const mWrap=document.querySelector(".modalWrap");
	const mWind=mWrap.querySelectorAll(".modalWindow");
	
	thmbs.forEach((thm)=>{
		thm.addEventListener("click",(e)=>{
			e.preventDefault();
			const num = thmbs.findIndex(list => list === thm);
			mWrap.classList.add("active");
			Array.from(mWind)[num].classList.add("open");
			mod=true;
		});
	});
	
	document.addEventListener("click", (e)=>{
		if (!e.target.closest(".modalWindow") && !e.target.closest(".questThmbs") && mod) {
			const openW=mWrap.querySelectorAll(".open");
			openW.forEach((o)=>{
				o.classList.remove("open");
			});
			mWrap.classList.remove("active");
			mod=false;
		}
	});
}